import { cn as e } from "../shared/utils.js";
import { menuItemVariants as t, menuPopupVariants as n, menuSeparatorVariants as r } from "./menu.styles.js";
import { forwardRef as i } from "react";
import { jsx as a } from "react/jsx-runtime";
import { Menu as o } from "@base-ui/react/menu";
//#region src/menu/menu.tsx
function s(e) {
	return /* @__PURE__ */ a(o.Root, { ...e });
}
var c = i(({ children: t, className: n, render: r, ...i }, s) => {
	let c = e("focus-visible:focus-ring-primary outline-none", n);
	return typeof t == "function" ? /* @__PURE__ */ a(o.Trigger, {
		ref: s,
		className: c,
		render: (e, n) => /* @__PURE__ */ a("button", {
			...e,
			children: t(n)
		}),
		...i
	}) : /* @__PURE__ */ a(o.Trigger, {
		ref: s,
		className: c,
		render: r,
		...i,
		children: t
	});
}), l = i((e, t) => /* @__PURE__ */ a(o.Portal, {
	ref: t,
	...e
})), u = i(({ align: e = "end", sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ a(o.Positioner, {
	ref: r,
	align: e,
	sideOffset: t,
	...n
})), d = i(({ className: t, ...r }, i) => /* @__PURE__ */ a(o.Popup, {
	ref: i,
	className: e(n(), t),
	...r
})), f = i(({ className: n, size: r = "md", state: i = "default", surface: s = "popup", ...c }, l) => /* @__PURE__ */ a(o.Item, {
	ref: l,
	className: e(t({
		size: r,
		state: i,
		surface: s
	}), n),
	...c
})), p = i(({ className: n, size: r = "md", state: i = "default", surface: s = "popup", ...c }, l) => /* @__PURE__ */ a(o.LinkItem, {
	ref: l,
	className: e(t({
		size: r,
		state: i,
		surface: s
	}), n),
	...c
}));
function m(e) {
	return /* @__PURE__ */ a(o.SubmenuRoot, { ...e });
}
var h = i(({ className: n, size: r = "md", state: i = "default", ...s }, c) => /* @__PURE__ */ a(o.SubmenuTrigger, {
	ref: c,
	className: e(t({
		size: r,
		state: i,
		surface: "popup"
	}), n),
	...s
})), g = i(({ className: t, ...n }, i) => /* @__PURE__ */ a(o.Separator, {
	ref: i,
	className: e(r(), t),
	...n
}));
s.displayName = "Menu.Root", c.displayName = "Menu.Trigger", l.displayName = o.Portal.displayName, u.displayName = o.Positioner.displayName, d.displayName = o.Popup.displayName, f.displayName = o.Item.displayName, p.displayName = o.LinkItem.displayName, m.displayName = "Menu.SubmenuRoot", h.displayName = o.SubmenuTrigger.displayName, g.displayName = o.Separator.displayName;
var _ = {
	Root: s,
	Trigger: c,
	Portal: l,
	Positioner: u,
	Popup: d,
	Item: f,
	LinkItem: p,
	SubmenuRoot: m,
	SubmenuTrigger: h,
	Separator: g
};
//#endregion
export { _ as MenuPrimitives };
